import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const UserManagementIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path
      fill="currentColor"
      d="M9.2 13.8c.9 0 1.8.1 2.5.3 4.1 1 5.7 4.3 5.7 4.3v1.8H1v-1.8s1.5-3.2 5.6-4.3c.7-.2 1.6-.3 2.5-.3zm6.7.1c.5 0 1 .1 1.4.2 3.6.9 5.2 3.4 5.6 4 .1.1.1.3.1.4v1.6h-3.7v-2.2c-.1-.1-.2-.4-.2-.4-.007-.014-.207-.41-.6-1-.5-.7-1.4-1.7-2.6-2.6m-6.6 1.8c-2.6 0-4.2.9-5.2 1.8q-.6.45-.9.9h12c-.2-.3-.5-.6-.7-.9-1.1-.9-2.7-1.8-5.2-1.8M9.1 4.8c2.3 0 4.1 1.9 4.1 4.1 0 1.4-.7 2.7-1.8 3.4-.6.4-1.4.7-2.2.7h-.1c-.8 0-1.6-.3-2.2-.7-1.1-.8-1.9-2-1.9-3.5 0-2.2 1.9-4 4.1-4m5.6-.1c2.3 0 4.1 1.9 4.1 4.1 0 1.5-.7 2.7-1.7 3.4-.6.4-1.4.7-2.2.7h-.1c-.2 0-.5-.1-.7-.1-.1 0-.2-.1-.3-.1.5-.5.8-1 1-1.6.2-.8.4-1.5.4-2.3s-.2-1.5-.5-2.3c-.2-.6-.6-1.2-1-1.7.3 0 .6-.1 1-.1M9.1 6.5c-1.2.1-2.3 1.1-2.3 2.3s1 2.3 2.3 2.3c1.2 0 2.3-1 2.3-2.3 0-1.2-1-2.3-2.3-2.3"
    />
  </BaseIcon>
)
